/*eslint-disable*/
module.exports = {
  header: cube.$id('header'),
  message: cube.$id('top-message-bar'),
  lang: cube.$id('js-navigation-lang'),
  fullHeaderHeight: 0,

  init: function() {
    cube.$$('.js-navigation-button').forEach(btn => {
      btn.onclick = function() {
        cube.$('html').classList.toggle('navigation-on');
        // Remove searchbar when click on menu button to avoid safari mobile menu bug
        if ($('#search-autocomplete').is(':visible')) {
          cube.$('body').classList.remove('HeaderMobileSearch-opened');
          cube.$('html').classList.remove('noscroll');
        }
        if (btn.classList.contains('menu-button')) {
          const openedNav = cube.$('html').classList.contains('navigation-on');
          btn.setAttribute('aria-expanded', openedNav);
          document.dispatchEvent(
            new Event(openedNav ? 'anly-open-menu' : 'anly-close-menu')
          );
        }
      };
    });

    this.updateFullHeaderHeight();

    /* Open the navigation if menuOpen boolean send true  */
    if (window.location.search === '?menuOpen=true') {
      cube.$('html').classList.add('navigation-on');
      cube.$$('.js-navigation-button').forEach(btn => {
        if (btn.classList.contains('menu-button')) {
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    }

    if (this.lang) this.lang.onclick = this.chooseLang;
  },

  updateFullHeaderHeight: function() {
    var self = this;

    self.fullHeaderHeight = self.header.offsetHeight;
    if (self.message && !self.header.classList.contains('sticky')) {
      self.fullHeaderHeight += self.message.offsetHeight;
    }
  },

  /* Display a submenu for change lang on mobile */
  chooseLang: function() {
    var showLangWrapper = cube.$id('js-navigation-show-lang'),
      heightOfSubMenu = showLangWrapper.clientHeight + 76 + 'px';

    if (showLangWrapper.style.bottom !== heightOfSubMenu) {
      showLangWrapper.style.bottom = heightOfSubMenu;
    } else {
      showLangWrapper.style.bottom = '0';
    }

    return false;
  },
};



// WEBPACK FOOTER //
// ./src/modules-es5/commons/layout/navigation.js